export default "__VITE_ASSET__BIjTubIt__"